<script>
	// import { Router, Route } from 'svelte-routing'

	import * as queryString from 'query-string'

	import Home from "./routes/Home.svelte";
	import Event from "./routes/Event.svelte";
	import Instrument from "./routes/Instrument.svelte"

	import { activePage, staticPath } from './stores.js';

	let staticFilesPath
	let videoFilesPath
	if(__ENV__ == 'development'){
		staticFilesPath = "./../static"
		videoFilesPath = staticFilesPath + "/videos"
	} else if(__ENV__ == 'staging') {
		staticFilesPath = "./static"
		// videoFilesPath = staticFilesPath + "/videos"
		videoFilesPath = "https://virtualtaiko.s3.ca-central-1.amazonaws.com"
	} else if(__ENV__ == 'production') {
		staticFilesPath = "./static"
		videoFilesPath = "https://virtualtaiko.s3.ca-central-1.amazonaws.com"
	}

	staticPath.set(staticFilesPath)
	const episodes = [{
		title: "Episode 1: Raijin, the God of Thunder",
		staticFilesPath: staticFilesPath,
		videoFilesPath: videoFilesPath,
		avatar: {
			name: "thunder",
			src: staticFilesPath + "/images/thunder",
			altText: "An endearing drawing of a young Raijin, god of thunder"
		},
		contextVideo: {
			contentSrc: videoFilesPath + "/ep-1-thunder-context-v1.mp4",
			captionSrc: videoFilesPath + "/ep-1-thunder-context-v1-captions.vtt"
		},
		instructionalVideo: {
			contentSrc: videoFilesPath + '/ep-1-thunder-instruction-v1.mp4', // parsed by DeckViewer component into 300px and 360px URLs
    	captionSrc: videoFilesPath + '/ep-1-thunder-instruction-captions-v4.vtt',
		}
	},{
		title: "Episode 2: Benten, the Goddess of Art",
		staticFilesPath: staticFilesPath,
		videoFilesPath: videoFilesPath,
		avatar: {
			name: "art",
			src: staticFilesPath + "/images/art",
			altText: "An endearing drawing of a young Benten, goddess of art"
		},
		contextVideo: {
			contentSrc: videoFilesPath + "/ep-2-art-context-v1.mp4",
			captionSrc: videoFilesPath + "/ep-2-art-context-captions-v1.vtt"
		},
		instructionalVideo: {
			contentSrc: videoFilesPath + '/episode-2-art-instruction-v1.mp4', // parsed by DeckViewer component into 300px and 360px URLs
    	captionSrc: videoFilesPath + '/ep-2-art-instruction-captions-v4.vtt',
		}
	},{
		title: "Episode 3: Fūjin, the God of Wind",
		staticFilesPath: staticFilesPath,
		videoFilesPath: videoFilesPath,
		avatar: {
			name: "wind",
			src: staticFilesPath + "/images/wind",
			altText: "An endearing drawing of a young Fūjin, god of thunder"
		},
		contextVideo: {
			contentSrc: videoFilesPath + "/ep-3-wind-context-v1.mp4",
			captionSrc: videoFilesPath + "/ep-3-wind-context-captions-v1.vtt"
		},
		instructionalVideo: {
			contentSrc: videoFilesPath + '/episode-3-wind-instruction-v1.mp4', // parsed by DeckViewer component into 300px and 360px URLs
    	captionSrc: videoFilesPath + '/ep-3-wind-instruction-captions-v4.vtt',
		}
	}]


	let pages = [{
			page: "home" 
		},{
			page: "event"
		},{
			page: "instrument",
			episodes: ["none", "Episode 1: Raijin, the God of Thunder", "Episode 2: Ame-no-Uzume, the Goddess of Art", "Episode 3: Fūjin, the God of Wind"]
		}]

	let activePage_value
	const unsubscribe = activePage.subscribe(value => {
		activePage_value = value;
	})

	$: console.log(activePage_value)


	const params = queryString.parse(location.search)
	console.log(params)
	if(params.page !== undefined){
		const possiblePage = params
		
		const matchingPage = pages.find( page => page.page === possiblePage.page)

		if(matchingPage !== undefined){
			const desiredPage = possiblePage
			console.log(desiredPage)
			if(matchingPage.page != "home"){
				if(matchingPage.page == "instrument"){
					console.log(matchingPage)
					console.log(matchingPage.episodes[1].toString())
					console.log(desiredPage.episode)
					if(desiredPage.episode !== undefined && matchingPage.episodes[desiredPage.episode - 1] !== undefined){
						desiredPage.episode = episodes[desiredPage.episode - 1]
						console.log(desiredPage)
					} else {
						desiredPage.episode = "none"
					}
				}
				activePage.set(desiredPage)
			}
		}
	}



</script>

{#if activePage_value.page == "home"}
	<Home></Home>
{:else if activePage_value.page == "instrument"}
	<Instrument episode={episodes[activePage_value.episode - 1] || "none" }/>
{:else if activePage_value.page == "event"}
	<Event></Event>
{/if}